import React from 'react';



import Manage_img from '../assets/images/school/mage.svg';
import Education_img from '../assets/images/school/exams-animate.svg';
import Connection_img from '../assets/images/school/kids-studying.svg';

import Desk_img from '../assets/images/school/desk.svg';
import Graduation_img from '../assets/images/school/graduation.svg';
import Medal_img from '../assets/images/school/medal.svg';

import IntroVideo from '../assets/intro2.mp4';

export const Content40DataSource = {
  wrapper: { className: 'home-page-wrapper content4-wrapper' },
  page: { className: 'home-page content4' },
  OverPack: { playScale: 0.3, className: '',always: false },
  titleWrapper: {
    className: 'page-title',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>نرم افزار جامع مدیریت هوشمند مدارس</p>
            </span>
          </span>
        ),
        className: '',
      },
      {
        name: 'content',
        className: 'page-subtitle',
        children: (
          <span>
            <p>
              مدتاک می کوشد تا با ایجاد بستری آنلاین و هوشمند در عین سادگی و
              صرفه جویی در وقت و هزینه، تحولی شگرف در مدیریت مراکز آموزشی، و
              مدارس پدید آورد به این امید که در راه آموزش و ارتقای سطح علمی
              فرزندان این سرزمین همراه و یاور مدارس باشد.
            </p>
          </span>
        ),
      },
    ],
  },
  video: {
    className: 'content4-video',
    children: {
      video: IntroVideo,
      image: 'https://zos.alipayobjects.com/rmsportal/HZgzhugQZkqUwBVeNyfz.jpg',
    },
  },
};
export const Feature00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '',always: false },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>مزایای اصلی</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: Desk_img,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                  <p>پیشبرد بهتر اهداف آموزشی</p>
              ),
            },
            {
              name: 'content',
              children: (
                  <p>
                    با استفاده از مکانیزم برنامه ریزی درسی و گزارش مطالعاتی
                    مدتاک دانش اموزان میتوانند به راحتی با برنامه درس بخوانند و
                    درکنار آن همواره شاهد نمودار پیش رفت خود نیز باشند
                  </p>,
                  <p>
                    بخش تکالیف درسی مدتاک نیز ارتباط و هماهنگی مورد نیاز میان
                    دانش آموزان و معلمان را به بهترین شکل فراهم آورده است.
                  </p>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: Graduation_img,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                    <p>آموزش بی وقفه</p>
              ),
            },
            {
              name: 'content',
              children: (
                  <p>
                    مدتاک امکان ایجاد یک محیط کلاسی آنلاین را به ساده ترین و
                    بهترین حالت ممکن به صورت شبانه روزی برایتان فراهم می آورد.
                  </p>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: Medal_img,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                    <p>افزایش رضایتمندی والدین</p>
              ),
            },
            {
              name: 'content',
              children: (
                  <p>
                    والدین با ارتباط موثر و کافی با معلم ها و مدیریت مدرسه، در
                    جریان وضعیت تحصیلی فرزند خود قرار می گیرند
                  </p>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Feature50DataSource = {
  wrapper: { className: 'home-page-wrapper content7-wrapper' },
  page: { className: 'home-page content7' },
  OverPack: { playScale: 0.3, className: '',always: false },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>امکانات سامانه</p>
          </span>
        ),
        className: 'title-h1',
      },
      { name: 'content', children: 'سامانه مدیریت مدارس مدتاک با چندین زیر سیستم یکپارچه' ,  className: 'sec-subtitle' },
    ],
  },
  tabsWrapper: { className: 'content7-tabs-wrapper' },
  block: {
    children: [
      {
        name: 'block0',
        tag: {
          className: 'content7-tag',
          text: {
            children: (
              <span>
                <span>
                  <p>بخش مدیریتی</p>
                </span>
              </span>
            ),
            className: 'content7-tag-name',
          },
          icon: { children: 'mobile' },
        },
        content: {
          className: 'content7-content',
          text: {
            className: 'content7-text',
            md: 14,
            xs: 24,
            children: (
              <span>
                <span>
                  <h3>مدیریت ثبت نام</h3>
                  <p>
                  پیش ثبت نام دانش آموزان به همراه پرداخت توسط درگاه اینترنتی
                  </p>
                  <br />
                  <h3>حضور و غیاب</h3>
                  <p>
                  حضور و غیاب هوشمند برای دانش آموزان، اولیا و کادر اداری
                  </p>
                  <br />
                  <h3>مدیریت وبسایت</h3>
                  <p>
                  طراحی واکنشگرا قالب سایت مدارس با سیستم مدیریت محتوای اختصاصی
                  </p>
                  <br />
                  <h3>نظر سنجی الکترونیکی</h3>
                  <p>
                  مدیریت نظرسنجی و ارزشیابی معلمین با ارائه گزارش جامع
                  </p>
                  <br />
                  <h3>امور شهریه</h3>
                  <p>
                  مدیریت و نظارت بر عملکرد مالی شهریه و هزینه های مدرسه
                  </p>
                  <br />
                </span>
              </span>
            ),
          },
          img: {
            className: 'content7-img',
            children:
              Manage_img,
            md: 10,
            xs: 24,
          },
        },
      },
      {
        name: 'block1',
        tag: {
          className: 'content7-tag',
          icon: { children: 'tablet' },
          text: {
            className: 'content7-tag-name',
            children: (
              <span>
                <p>بخش آموزشی</p>
              </span>
            ),
          },
        },
        content: {
          className: 'content7-content',
          text: {
            className: 'content7-text',
            md: 14,
            xs: 24,
            children: (
              <span>
                <h3>آزمون آنلاین</h3>
                <p>
                برگزاری آزمون آنلاین ترکیبی با بیش از ۷ نوع مختلف از سؤالات
                </p>
                <br />
                <h3>سامانه مطالعاتی</h3>
                <p>
                نظارت، مشاوره و برنامه ریزی برای عملکرد مطالعه دانش آموزان
                </p>
                <br />
                <h3>تکالیف الکترونیکی</h3>
                <p>
                ایجاد انواع تکلیف برای دانش آموزان با امکان پاسخگویی و ثبت نمره
                </p>
                <br />
                <h3>گزارشات نموداری</h3>
                <p>
                نظارت، مقایسه و سنجش دقیق عملکرد دانش آموزان و مشاهده کارنامه
                </p>
                <br />
                <h3>انتشار کارنامه</h3>
                <p>
                اعلام نتایج و اطلاع رسانی به دانش آموزان
                </p>
                <br />
              </span>
            ),
          },
          img: {
            className: 'content7-img',
            md: 10,
            xs: 24,
            children: Education_img,
          },
        },
      },
      {
        name: 'block2',
        tag: {
          className: 'content7-tag',
          text: {
            children: (
              <span>
                <p>بخش ارتباطی</p>
              </span>
            ),
            className: 'content7-tag-name',
          },
          icon: { children: 'laptop' },
        },
        content: {
          className: 'content7-content',
          text: {
            className: 'content7-text',
            md: 14,
            xs: 24,
            children: (
              <span>
                <h3>چت و مدیریت پیام ها</h3>
                <p>
                تبادل پیام بین کاربران مدرسه به صورت نامحدود، بدون هزینه جانبی
                </p>
                <br />
                {/* <h3>بخش پیام کوتاه</h3>
                <p>
                پنل پیامکی برای ارتباط مدیر با معلمین، اولیا و دانش آموزان
                </p> */}
                <br />
                <h3>بخش اطلاعیه ها</h3>
                <p>
                امکان ثبت اطلاعیه و انتشار آن در سامانه برای دانش آموزان، اولیا و معلمان
                </p>
                <br />
              </span>
            ),
          },
          img: {
            className: 'content7-img',
            md: 10,
            xs: 24,
            children: Connection_img,
          },
        },
      }
    ],
  },
};
export const Feature60DataSource = {
  wrapper: { className: 'home-page-wrapper feature6-wrapper' },
  OverPack: { className: 'home-page feature6', playScale: 0.3, always: false },
  Carousel: {
    className: 'feature6-content',
    dots: false,
    wrapper: { className: 'feature6-content-wrapper' },
    titleWrapper: {
      className: 'feature6-title-wrapper',
      barWrapper: {
        className: 'feature6-title-bar-wrapper',
        children: { className: 'feature6-title-bar' },
      },
      title: { className: 'feature6-title' },
    },
    children: [
      {
        title: {
          className: 'feature6-title-text',
          children: (
            <span>
              <p>مدتاک؛ مورد اعتماد شما</p>
            </span>
          ),
        },
        className: 'feature6-item',
        name: 'block0',
        children: [
          {
            md: 12,
            xs: 24,
            className: 'feature6-number-wrapper',
            name: 'child0',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit',
                children: (
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '33',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <p>تعداد مراکز آموزشی فعال</p>
                </span>
              ),
            },
          },
          {
            md: 12,
            xs: 24,
            className: 'feature6-number-wrapper',
            name: 'child1',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit',
                children: (
                  <span>
                    <span>
                      <span>
                        <p>
                          <br />
                        </p>
                      </span>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '12,000',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <p>تعداد دانش آموزان مدتاک</p>
                </span>
              ),
            },
          },
          // {
          //   md: 8,
          //   xs: 24,
          //   className: 'feature6-number-wrapper',
          //   name: 'child2',
          //   number: {
          //     className: 'feature6-number',
          //     unit: {
          //       className: 'feature6-unit',
          //       children: (
          //         <span>
          //           <p>
          //             <br />
          //           </p>
          //         </span>
          //       ),
          //     },
          //     toText: true,
          //     children: '126',
          //   },
          //   children: {
          //     className: 'feature6-text',
          //     children: (
          //       <span>
          //         <p>تعداد جلسات درحال برگزاری</p>
          //       </span>
          //     ),
          //   },
          // },
        ],
      },
    ],
  },
};